var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dx-grid',{ref:"grid",attrs:{"url":"kollelFormLogs","columns":_vm.columns,"title":_vm.title,"actions":_vm.actions,"expandedOptions":{
            enabled: true,
            template: 'kollel-log-details',
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }